// eslint-disable-next-line no-unused-vars
import webpackEntry from 'webpack-entry';

import packageJson from '../../package.json';
import { PluginManifest, PluginStore } from 'graylog-web-plugin/plugin';

import AuditLogPage from 'AuditLogPage';
import AuditLogConfigurationPage from 'AuditLogConfigurationPage';

PluginStore.register(new PluginManifest(packageJson, {
  routes: [
    { path: '/system/auditlog', component: AuditLogPage },
    { path: '/system/auditlog/configuration', component: AuditLogConfigurationPage },
  ],

  systemnavigation: [
    { path: '/system/auditlog', description: 'Audit Log', permissions: 'auditlog_status:read' },
  ],
}));



// WEBPACK FOOTER //
// ./src/web/index.jsx